import { inputBaseClasses } from '@mui/material'
import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapperHeader: {
    marginTop: {
      xs: 'unset',
      sm: '-44px',
    },
    maxWidth: '680px',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'border.main',
    minHeight: {
      sm: '424px',
      xs: 'unset',
    },
    paddingLeft: {
      xs: '24px !important',
      md: '48px',
    },
    paddingTop: {
      xs: '24px !important',
      md: '48px',
    },
    gap: '36px',
    borderRadius: '16px',
    paddingBottom: {
      xs: '24px !important',
      md: 'unset',
    },
    paddingRight: {
      xs: '24px !important',
      md: 'unset',
    },
    position: 'relative',
    overflow: 'hidden',
  },
  darkTextField: {
    color: 'common.white',
    width: '100%',
    borderColor: 'common.white',
    '& .MuiInputBase-root': {
      color: 'common.white',
      backgroundColor: 'border.contrastText',
      border: '1px solid',
      borderColor: 'common.white',
      '&.Mui-focused': {
        backgroundColor: 'custom.lightGrey !important',
      },
      '&:hover': {
        backgroundColor: 'custom.lightGrey !important',
      },
      '&::before': {
        borderBottom: '1px solid',
        borderColor: 'border.light',
      },
      '&:hover::before': {
        borderBottom: '1px solid',
        borderColor: 'common.white',
      },
      '&.Mui-focused::before': {
        borderBottom: '1px solid',
        borderColor: 'border.light',
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'common.white',
      },
      '&:hover fieldset': {
        borderColor: 'common.white',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ffffff !important',
      },
    },
    [`& .${inputBaseClasses.root}:hover input::placeholder`]: {
      color: '#ffffff !important',
      opacity: '1',
    },
    [`& .${inputBaseClasses.root} input::placeholder`]: {
      color: '#ffffff !important',
      opacity: '1',
    },
    [`& .${inputBaseClasses.root}:hover svg`]: {
      color: '#ffffff !important',
    },
    [`& .${inputBaseClasses.root} svg`]: {
      color: '#ffffff !important',
    },
    [`& .${inputBaseClasses.root} input`]: {
      color: '#ffffff !important',
    },
    '& input:-webkit-autofill, & input:-webkit-autofill:focus, & input:-webkit-autofill:hover, & textarea:-webkit-autofill, & textarea:-webkit-autofill:focus, & textarea:-webkit-autofill:hover':
      {
        WebkitBoxShadow: '0 0 0 1000px transparent inset',
        WebkitTextFillColor: '#fff',
        caretColor: '#fff',
        backgroundColor: 'transparent',
        transition: 'background-color 5000s ease-in-out 0s',
      },
  },
  image: {
    maxHeight: '374px',
    width: '515px',
    borderTopLeftRadius: '8px',
    display: {
      xs: 'none',
      md: 'block',
    },
    position: 'absolute',
    borderTop: '12px solid',
    borderLeft: '12px solid',
    borderColor: '#202323',
    right: 0,
    bottom: -40,
    overflow: 'hidden',
    img: {
      borderRadius: '8px',
      objectFit: 'inherit !important',
    },
  },
  formWrapper: {
    display: 'flex',
    gap: 2,
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  },
  button: {},
  textFieldWrapper: {
    width: {
      xs: '100%',
      sm: '480px',
    },
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
